import { gql } from "@apollo/client";
import { FilterValueMetaNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const QUERY_UNDOCUMENTED_FILTER_METADATA = gql`
  ${FilterValueMetaNoNestingFragment}
  query QueryUndocumentedFilterMetadata($filters: [FilterValueMetaInput!]!) {
    undocumentedFilterMetadata(filters: $filters) {
      ...FilterValueMetaNoNesting
    }
  }
`;
